<script setup>
import { useNavigationItems } from '@/composables/useNavigationItems'
import { defineAsyncComponent, reactive, ref, watch } from 'vue'

const CmsBlock = defineAsyncComponent(
  () => import('@/components/basic/atoms/CmsBlock.vue')
)
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const TheDialog = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheDialog.vue')
)

const menu = ref(false)
const flyoutVisibility = reactive({})

const { navigationItems } = useNavigationItems()

watch(navigationItems, (items) => {
  items.forEach((item) => {
    if (item.flyout) {
      flyoutVisibility[item.name] = false
    }
  })
})
</script>

<template>
  <div
    id="hamburger"
    class="d-inline-flex d-md-none px-3"
    aria-label="Menu"
    @click="menu = !menu"
  >
    <div class="flex-column justify-center h-100">
      <SvgWrapper
        href="icon_svg_hamburger_menu"
        use="icon_svg_hamburger_menu"
        dimensions="30"
      />
      <TheDialog v-model="menu" @close="menu = false">
        <VList>
          <VListItem
            v-for="navigationItem in navigationItems"
            :key="navigationItem.name"
            :href="navigationItem.flyout ? '' : navigationItem.url"
            class="text-center"
          >
            {{ navigationItem.name }}
            <VIcon v-if="navigationItem.flyout">custom:right</VIcon>
            <TheDialog
              v-if="navigationItem.flyout"
              class="rotate-90"
              activator="parent"
              v-model="flyoutVisibility[navigationItem.name]"
              @close="flyoutVisibility[navigationItem.name] = false"
            >
              <div class="d-flex flex-column h-100">
                <CmsBlock
                  :blockData="navigationItem.flyout"
                  class="overflow-scroll flex-grow-1"
                />
                <div class="flex-grow-0 pa-3">
                  <VBtn
                    block
                    :href="navigationItem.url"
                    :text="navigationItem.name"
                  />
                </div>
              </div>
            </TheDialog>
          </VListItem>
        </VList>
      </TheDialog>
    </div>
  </div>
</template>

<style scoped>
:deep(.flyout) {
  li.clearfix {
    display: flex;
    flex-direction: column;
    ul {
      width: 100% !important;
      a {
        display: flex;
        padding: 0.5rem 0;
      }
    }
    > ul:not(:first-child) {
      margin-top: 1rem;
    }
    > ul:last-child {
      margin-bottom: 1rem;
    }
  }
  li.headline {
    margin: 0 10px 10px 10px;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 2px solid rgb(var(--v-theme-light-ochre));
    padding: 0.5rem 0;
    letter-spacing: 0.5px;
  }

  a {
    letter-spacing: 0.5px;
  }
}
</style>
